var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeriWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.64 182.5H49.36C41.98 182.5 36 176.53 36 169.16V53.11C36 49.5 37.47 46.04 40.06 43.53L63.09 21.26C65.58 18.85 68.91 17.5 72.38 17.5H150.64C158.02 17.5 164 23.47 164 30.84V169.17C164 176.54 158.02 182.51 150.64 182.51V182.5Z",
    fill: "white",
    stroke: "#E98305",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6 74.75C107.6 77.49 107.5 82.75 107.29 90.52C107.21 91.75 107.17 92.65 107.17 93.22C106.35 98.99 105.84 104.02 105.64 108.32H94.2901C94.0801 104.02 93.5701 98.99 92.7601 93.22L92.7001 90.52C92.4501 84.22 92.3301 78.96 92.3301 74.75H107.61H107.6ZM107.05 123.85H92.8101V112.93H107.05V123.85Z",
    fill: "#E98305"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeriWarning);
export default __webpack_public_path__ + "static/media/veri_warning.3f25ef3f78b6137aaaf7174c63452a1b.svg";
export { ForwardRef as ReactComponent };